import { Logger } from '../logger/Logger'
import { nuxt } from '../logger/LogKey'

export default async function generateDataUrl (svgFile : string) : Promise<string> {
  try {
    const content = await fetch(svgFile).then((respsonse) => respsonse.text())
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(content)}`
  } catch (e) {
    Logger.error(nuxt, `[SVG SERVICE] Could not generate data url for ${svgFile}`, e)
    return ''
  }
}
